import { put, call } from 'redux-saga/effects';
import { NotificationAction, UIAction } from '../actions';
import { NotificationService } from '../services';
import { generateReadableError } from 'hooks';

export function* sendNotification(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  yield put(NotificationAction.sendNotificationSuccess(null));
  try {
    const { data } = yield call(NotificationService.getInstance().sendNotification, action.payload);
    yield put(NotificationAction.sendNotificationSuccess(data));
    yield put(UIAction.showMainLoading(false));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}







